import { useWalletStore } from '../stores/wallet';

export default function useLoginWallet(network) {
  let walletStore = useWalletStore();
  const loginTRX = async (network) => {
    if (!window.tronWeb) {
      return;
    }
    if (!window.tronWeb.defaultAddress.base58) {
      await window.tronWeb.request({
        method: 'tron_requestAccounts',
        params: {
          websiteIcon: 'https://hk.tpstatic.net/tokenpocket.png',
          websiteName: 'Token Claim',
        },
      });
    }
    if (!window.tronWeb.defaultAddress.base58) {
      return;
    }
    let chainId = '728126428';
    if (process.env.VUE_APP_ENV === 'dev') {
      chainId = '3448148188'
    }
    const icon = getNetworkIcon('tron', '728126428');
    const info = {
      chainId: chainId,
      account: window.tronWeb.defaultAddress.base58,
      ns: 'tron',
      icon
    };
    walletStore.walletInfo['TRX'] = info;
  };

  const getNetworkIcon = (ns, chainId) => {
    const blockChainList = JSON.parse(localStorage.getItem('blockChainList')) || [];
    const blockchain = blockChainList.find(
      (item) => item.chain_id === chainId && item.ns === ns
    );
    return blockchain ? blockchain.icon_url : ''
  }

  return { loginTRX };
}
